import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../toolkit/uicomponentcss';
import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';

export interface ListGroupCSSStyle extends UIComponentCSSStyle
{
    getCallerHeaderTitle():object;
    getCallerDescriptionDivCSSStyle():object;
    getCreateButtonDivCSSStyle(width: string):object;
    getListHeaderWrapperDivCSSStyle():object;
    getListTitleDivCSSStyle():object;
    getListLabelCSSStyle():object;
    getButtonDivCSSStyle():object;
}

export class ListGroupCSSStyleImpl extends UIComponentCSSStyleImpl implements ListGroupCSSStyle
{
    getWrapperCSSStyle():object
    {
        return{
            width: "100%",
           
            textAlign: "center"
        };
    }

    getCallerHeaderTitle():object
    {
        return{
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 900,
            letterSpacing: 0,
            width: "100%",
            textAlign: "center",
        };
    }

    getCallerDescriptionDivCSSStyle():object
    {
        return{
            textAlign: "center",
            height:'auto',
            color: '#6D6D6D',
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 500,
            letterSpacing: 0,
            width: "100%",
        };
    }

    getCreateButtonDivCSSStyle(width: string):object
    {
        return{
            width: width,
            minWidth:"95px",
            display: "inline-block",
            marginTop: "0px",
            margin: "0 !important",
            marginBottom:'0px',
        };
    }

    getListHeaderWrapperDivCSSStyle():object
    {
        return{
            width:'100%',height:'auto',display:'flex'
        };
    }

    getListTitleDivCSSStyle():object
    {
        return{
            width:'50%',textAlign:'left',height:'100%',marginLeft:'0%'
        };
    }

    getListLabelCSSStyle():object{
        return{
            width:'100%',height:'100%',fontWeight:900
        };
    }

    getButtonDivCSSStyle():object
    {
        return{
            width:'50%',height:'100%',textAlign:'right',marginRight:'0%'
        };
    }

   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/listgroup/listgroupcss.tsx